import { ComponentRestrictions } from "../../app.config";

export class AppEnviroment {
    public static DatePickerID: string = "";
    public static IsValid: boolean;
    public static MaxYear: string = ComponentRestrictions.date.maxYear;
    public static MinYear: string = ComponentRestrictions.date.minYear;
    public static MaxDate: string = ComponentRestrictions.date.max;
    public static MinDate: string = ComponentRestrictions.date.min;
}